export default "__VITE_ASSET__pLjvl_Xd__"